export default __webpack_public_path__ + "static/media/CovidCareCentres.4edb93b1.svg";